module.exports = __webpack_public_path__ + "static/greyvelourbunnyonesie-766ac07c48cf92d235c9fc85a0ca7b75.jpeg";